import { Col, Row } from 'ui';
import { Skeleton, type SkeletonProperties } from 'ui';
import { TwoColumnLayout } from '../two-column-layout';

type P = {
  header?: SkeletonProperties;
  left: SkeletonProperties[];
  right: SkeletonProperties[];
};

const HeaderTwoColumnLayoutSkeleton = ({ header, left, right }: P) => (
  <Row gutter={['ms', 'xl']}>
    {header ? (
      <Col span={24}>
        <Skeleton active paragraph={header.paragraph} title={false} {...header} />
      </Col>
    ) : null}

    <Col span={24}>
      <TwoColumnLayout
        left={
          <Row gutter={[0, 'ms']}>
            {left.map((section, index) => (
              // eslint-disable-next-line react/no-array-index-key -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
              <Col key={`left-column-skeleton-row-${index}`} span={24}>
                <Skeleton active paragraph={section.paragraph} title={false} {...section} />
              </Col>
            ))}
          </Row>
        }
        right={
          <Row gutter={[0, 'ms']}>
            {right.map((section, index) => (
              // eslint-disable-next-line react/no-array-index-key -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
              <Col key={`right-column-skeleton-row-${index}`} span={24}>
                <Skeleton active paragraph={section.paragraph} title={false} {...section} />
              </Col>
            ))}
          </Row>
        }
      />
    </Col>
  </Row>
);

export default HeaderTwoColumnLayoutSkeleton;
